import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAvailCompTables,
    GetAvailCompColumns,
    UpdateCompanion,
    GetCompanionList,
    LoadCompanionSchema
 } from '../../../actions/CompanionActions';
import AutoComplete from '../../../components/AutoComplete';



const EditCompanion = (props) => {
    const dispatch = useDispatch();
    const companionInfo = useSelector(state => state.companionInfo.value);
    const [selTable, setSelTable] = useState('');
    const [selColumns, setSelColumns] = useState([]);
    const [compName, setCompName] = useState('');
    const editSchema = useRef(undefined);

    useEffect(() => {
        console.log(props.schemaId);
        LoadCompanionSchema(props.schemaId, receiveCompSchema);
        //GetAvailCompTables(tableCallBack);
    }, [])

    useEffect(() => {
        if(selTable !== '') {
            setSelColumns([]);
            setCompName(selTable);
        }
    }, [selTable])

    const receiveCompSchema = (schema) => {
        console.log(schema);
        editSchema.current = schema;

        setSelTable(schema.companionTable);
        setCompName(schema.companionName);
        GetAvailCompColumns(schema.companionTable, fetchColumnCallback);
    }

    const fetchColumnCallback = (res) => {
        console.log(res);
        console.log(editSchema.current);
        let cols = [];
        res.forEach((col) => {
            let newCol = {
                colName: col,
                isSelected: false,
                isId: false,
                readOnly: false
            }
            let es = editSchema.current.columnData.find(f => f.columnName === col);
            console.log(es);
            if(es) {
                newCol.isSelected = true;
                if(editSchema.current.identityColumn === col) newCol.isId = true;
                newCol.readOnly = es.isReadOnly;
            }
            cols.push(newCol);
        });
        setSelColumns(cols);
    }

    const updateCompanionClick = () => {
        let newComp = {
            tableName: selTable,
            compName: compName,
            columns: []
        };

        selColumns.forEach(col => {
            if(col.isSelected) {
                newComp.columns.push({
                    colName: col.colName,
                    isReadOnly: col.readOnly,
                    isIdCol: col.isId
                });
            }
        });
        UpdateCompanion(newComp, dispatch, afterUpdate)

    }

    const afterUpdate = () => {
        //GetCompanionList(dispatch);
        props.close();
    }

    const changeCheck = (e, col, type) => {
        let columns = [...selColumns];
        let editCol = columns.find(f => f.colName === col.colName);
        if(editCol) {
            switch(type) {
                case 'show':
                    editCol.isSelected = e.target.checked;
                    break;
                case 'id':
                    let otherId = columns.find(f2 => f2.isId === true);
                    if(otherId) {
                        otherId.isId = false;
                    }
                    editCol.isId = e.target.checked;

                    break;
                case 'readonly':
                    editCol.readOnly = e.target.checked;
                    break;
            }
            setSelColumns(columns);
        }
    }

    return (
    <div className='td-dialogue-container'>
        <div className='td-dialogue card' style={{ width: '400px', height: '550px' }}>
            <div className='card-header'>
                Edit Companion Table
                <button
                  type='button'
                  className='btn-close'
                  onClick={() => props.close()}
                />
              </div>
              {editSchema.current !== undefined &&
              <div
                className='card-body ps-4'
                style={{ maxHeight: '500px', overflow: 'auto' }}
              >

                <label className='form-label'>Companion Table:</label>
                <span className='ps-2' style={{fontWeight: '600'}}>{editSchema.current.companionTable}</span>

                <div>
                    <label className='form-label'>Companion Name:</label>
                    <input value={compName} onChange={(v) => setCompName(v.target.value)} className='form-control'></input>
                </div>

                {selTable !== '' && <div className='mt-3'>

                    <div className='mt-2 coolScroll' style={{height: '180px', maxHeight: '180px', width: '350px', overflow : 'auto'}}>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{minWidth: '150px'}}>Column</th>
                                    <th>Show</th>
                                    <th className='ps-2'>Id col</th>
                                    <th className='ps-2'>Read Only</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selColumns.map((col) => (
                                    <tr key={col.colName}>
                                        <td>{col.colName}</td>
                                        <td className='ps-2'><input className='form-check-input' onChange={(e) => changeCheck(e, col, 'show')} type='checkbox' checked={col.isSelected} /></td>
                                        <td className='ps-3'><input className='form-check-input' onChange={(e) => changeCheck(e, col, 'id')} type='checkbox' checked={col.isId} /></td>
                                        <td className='ps-3'><input className='form-check-input' onChange={(e) => changeCheck(e, col, 'readonly')} type='checkbox' checked={col.readOnly} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                    <div className='d-grid gap-2'>
                        <button onClick={updateCompanionClick} className='btn btn-primary mt-4'> Update Companion </button>
                    </div>


                </div>}


            </div>
            }
        </div>
    </div>
    );
}

export default EditCompanion;